
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import { mapGetters } from "vuex";
export default {
components: {
Tabbar,
TabbarItem
},
data(){
return {
bottomImg:{
class:require("@/common/image/homePage/class.png"),
classActive:require("@/common/image/homePage/classActive.png"),
headPage:require("@/common/image/homePage/headPage.png"),
headPageActive:require("@/common/image/homePage/headPageActive.png"),
mine:require("@/common/image/homePage/mine.png"),
mineActive:require("@/common/image/homePage/mineActive.png"),
study:require("@/common/image/homePage/study.png"),
studyActive:require("@/common/image/homePage/studyActive.png"),
}
}
},
computed:{
...mapGetters(["user"]),
showItem(){
if(this.$route.name === 'Learn' && !this.user) {
this.$router.push({
path:'/login',
query: {
from: '/Learn'
}
})
}
return this.$route.name
}
}
};



// WEBPACK FOOTER //
// ./src/components/bottom.vue